var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelCancelled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-cancelled_svg__a",
    x1: "83.588%",
    x2: "16.412%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F09819"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3D452"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#202E4A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-cancelled_svg__a)",
    strokeWidth: 2,
    d: "M9.744 5.625h9.431a2.2 2.2 0 012.2 2.2V22.5h0-13.83V7.825a2.2 2.2 0 012.2-2.2z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 1.65,
    d: "M13.276 12.25h5.029m-5.029 3.375h5.029"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeWidth: 1.65,
    d: "M3.2 1h9.43a2.2 2.2 0 012.2 2.2v20.3h0H1V3.2A2.2 2.2 0 013.2 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeWidth: 1.65,
    d: "M7.13 17.875H8.7a1.1 1.1 0 011.1 1.1V23.5h0-3.77v-4.525a1.1 1.1 0 011.1-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 1.65,
    d: "M5.401 6.625h5.029M5.401 10h5.029m-5.029 3.375h5.029"
  }))));
}
export default SvgHotelCancelled;